import { render, staticRenderFns } from "./KSlider.vue?vue&type=template&id=5c3882e3&scoped=true&"
import script from "./KSlider.vue?vue&type=script&lang=js&"
export * from "./KSlider.vue?vue&type=script&lang=js&"
import style0 from "./KSlider.vue?vue&type=style&index=0&id=5c3882e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3882e3",
  null
  
)

export default component.exports